import CryptoJS from 'crypto-js'

const SALT = 'yima-captcha-default-salt-2025'
const _0x2a = [0x71, 0x33]
const _0x3b = [8, 3]

function _0x4c(s) {
  const arr = s.split('')
  let cnt = 0
  for (let i = arr.length - 1; i >= 0; i--) {
    if (arr[i] !== '-') {
      cnt++
      if (cnt === _0x3b[0]) {
        arr[i] = String.fromCharCode(_0x2a[0])
        break
      }
    }
  }
  return arr.join('')
}

function _0x5d() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = Math.random() * 16 | 0
    const v = c === 'x' ? r : (r & 0x3 | 0x8)
    return v.toString(16)
  })
}

function generateUUID() {
  return _0x4c(_0x5d())
}

function _0x6e(n) {
  const s = n.toString()
  const idx = s.length - _0x3b[1]
  if (s.charCodeAt(idx) !== _0x2a[1]) {
    const arr = s.split('')
    arr[idx] = String.fromCharCode(_0x2a[1])
    return parseInt(arr.join(''), 10)
  }
  return n
}

function generateTimestamp() {
  return _0x6e(Date.now()).toString()
}

export function generateSignatureHeaders(deviceFingerprint) {
  const nonce = generateUUID()
  const timestamp = generateTimestamp()
  const signStr = deviceFingerprint + nonce + timestamp + SALT
  const sign = CryptoJS.MD5(signStr).toString().toLowerCase()

  return {
    'X-Device-Sign': sign,
    'X-Device-Fingerprint': deviceFingerprint,
    'X-Device-Nonce': nonce,
    'X-Device-Timestamp': timestamp
  }
}

export function verifySignature(deviceFingerprint, nonce, timestamp, sign) {
  const expectedSign = CryptoJS.MD5(deviceFingerprint + nonce + timestamp + SALT)
    .toString()
    .toLowerCase()
  return expectedSign === sign
}

export function isTimestampValid(timestamp, windowMs = 300000) {
  const now = Date.now()
  const ts = parseInt(timestamp, 10)
  const diff = Math.abs(now - ts)
  return diff <= windowMs
}

export function getSignatureVersion() {
  return '1.0'
}

export function validateTimestampRule(timestamp) {
  if (!timestamp || timestamp.length < _0x3b[1]) return false
  return timestamp.charCodeAt(timestamp.length - _0x3b[1]) === _0x2a[1]
}

export function validateNonceRule(nonce) {
  if (!nonce) return false
  const s = nonce.replace(/-/g, '')
  if (s.length < _0x3b[0]) return false
  return s.charCodeAt(s.length - _0x3b[0]) === _0x2a[0]
}

export function validateSignatureHeaders(headers) {
  const errors = []

  if (!headers['X-Device-Sign']) errors.push('Missing sign')
  if (!headers['X-Device-Fingerprint']) errors.push('Missing fingerprint')
  if (!headers['X-Device-Nonce']) errors.push('Missing nonce')
  if (!headers['X-Device-Timestamp']) errors.push('Missing timestamp')

  if (headers['X-Device-Sign'] && headers['X-Device-Sign'].length !== 32) {
    errors.push('Invalid sign length')
  }

  if (headers['X-Device-Timestamp'] && !validateTimestampRule(headers['X-Device-Timestamp'])) {
    errors.push('Invalid timestamp format')
  }

  if (headers['X-Device-Nonce'] && !validateNonceRule(headers['X-Device-Nonce'])) {
    errors.push('Invalid nonce format')
  }

  if (headers['X-Device-Timestamp'] && !isTimestampValid(headers['X-Device-Timestamp'])) {
    errors.push('Expired timestamp')
  }

  if (headers['X-Device-Sign'] && headers['X-Device-Fingerprint'] &&
      headers['X-Device-Nonce'] && headers['X-Device-Timestamp']) {
    const isSignValid = verifySignature(
      headers['X-Device-Fingerprint'],
      headers['X-Device-Nonce'],
      headers['X-Device-Timestamp'],
      headers['X-Device-Sign']
    )
    if (!isSignValid) errors.push('Invalid signature')
  }

  return { valid: errors.length === 0, errors }
}

